//routes
export const Video_box = "/"
export const Login_box = "/login"
export const Booking_box = "/booking"
export const Setting_box = "/setting"
export const Last_page = "/last"
export const Home_page = "/home"
export const VIEW_TEMPLE = "/view_temple"
export const VIEW_BLOGS = "/blogs"
export const BADRI_NATH = "/badrinath_temple"
export const VIEW_BOOKING = "/view_booking"

//image url
export const img_url1 = "https://upload.wikimedia.org/wikipedia/commons/b/b2/Borobudur_%28Central_Java%2C_Indonesia%29_%2851111682742%29.gif"
export const img_url2 = "https://d368ufu7xgcs86.cloudfront.net/3547-1548399342.jpg"
export const img_url3 = "https://d368ufu7xgcs86.cloudfront.net/3554-1548324856.jpg"
export const img_url4 = "https://d368ufu7xgcs86.cloudfront.net/3554-1548324856.jpg"
export const img_url5 = "https://d368ufu7xgcs86.cloudfront.net/3555-1548325921.jpg"
export const img_url6 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR98dwludQVvCXo-LqeHXsixlY1dsrDJJSbiQ&usqp=CAU"
export const img_url7 = "https://d368ufu7xgcs86.cloudfront.net/3559-1548327227.jpg"
export const img_url8 = "https://d368ufu7xgcs86.cloudfront.net/3560-1548327551.jpg"
export const img_url9 = "https://d368ufu7xgcs86.cloudfront.net/3571-1548331187.jpg"
export const img_url10 = "https://d368ufu7xgcs86.cloudfront.net/3569-1548330834.jpg"
export const img_url11 = "https://www.tourmyindia.com/blog//wp-content/uploads/2017/08/lord-shiva.jpg"
export const img_url12 = "https://www.tourmyindia.com/blog//wp-content/uploads/2017/08/Lord-Brahma.jpg"
export const img_url13 = "https://www.tourmyindia.com/blog//wp-content/uploads/2017/08/Lord-Vishnu.jpg"
export const img_url14 = "https://www.tourmyindia.com/blog//wp-content/uploads/2017/08/goddess-laxmi.jpg"
export const img_url15 = "https://d368ufu7xgcs86.cloudfront.net/3569-1548330834.jpg"
export const img_url16 = "https://d368ufu7xgcs86.cloudfront.net/3569-1548330834.jpg"
export const img_url17 = "https://d368ufu7xgcs86.cloudfront.net/3569-1548330834.jpg"
export const img_url18 = "https://d368ufu7xgcs86.cloudfront.net/3569-1548330834.jpg"
export const img_url19 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBPa9sCd3zn2ZQUETwQFlIKdQ8h-ZkyJxBhw&usqp=CAU"
export const img_url20 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6n3o3ZSyTcm8RonqvBVIjAxm5Id52pWBZiw&usqp=CAU"
export const img_url21 = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbuf-JRqk4SOXWEYClZ5req5cDw4ueMJxulg&usqp=CAU"

